import React from 'react';
import Swiper from 'react-id-swiper';
import './style/swiper.min.css';
import styles from './index.less';
import debounce from 'lodash.debounce';

/**
 * swiper 组件的dependence
 *  "lodash.debounce": "4.0.8",
 *  "react-id-swiper": "4.0.0",
 *  "swiper": "5.3.1",
 * 注意： !!!
 * 目前在不兼容IE11以下的情况下, 可以正常使用
 * 但是需要兼容IE9的情况下, 当前swiper版本无法使用
 * 需要使用Swiper 2.0.0 版本进行兼容适配
 * https://2.swiper.com.cn/demo/index.html - swiper2 demo
 * https://2.swiper.com.cn/api/index.html - swiper2 api
 *
 */
export default class SimpleSwiper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.ref = React.createRef();

    this.onResize = debounce(() => {
      this.ref.current && this.ref.current.swiper.update();
    }, 500);
  }
  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }
  render() {
    const { params, children, isDemo } = this.props;
    let demoParams = {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      spaceBetween: 10
    };

    return isDemo ? (
      <div className={styles.swiperDemoBox}>
        <Swiper ref={this.ref} {...demoParams}>
          {children}
        </Swiper>
      </div>
    ) : (
      <Swiper ref={this.ref} {...params}>
        {children}
      </Swiper>
    );
  }
}

SimpleSwiper.defaultProps = {
  isDemo: false
};

/*
使用方法:

    .pageSwiperContent {
      width: 100%;
      height: 100%;
    }

    import SimpleSwiper from '@src/components/simple-swiper';

    const params = {
      loop: true,
      containerClass: styles.pageSwiperContent,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      spaceBetween: 10
    };
   注意： 当设置了isDemo后，外面的setting属性就会不起作用。
   <SimpleSwiper params={params} isDemo>{[0, 1, 2, 3, 4].map((val, index) => <div key={val} index={val} />)}</SimpleSwiper>
* */
